import moment from 'moment';
import template from './bookingChange.html';
import { BookingStateChangeTypes } from "shared-types/index";
import DateUtilsService from 'external-services/date-utils-service';
const NS = 'BookingChange';

export default function BookingChange($filter) {
  "ngInject";

  return {
    bindToController: true,
    controller: function () { },
    controllerAs: 'vm',
    link: link,
    restrict: 'E',
    scope: {
      change: '='
    },
    template
  };


  function link(scope) {
    var vm = scope.vm;
    if (!vm.change || !vm.change.changeList) {
      return;
    }

    // process all the changes
    var dateTimeFormat = vm.change.type === BookingStateChangeTypes.MOVED ? 'dd MMM yy h:mma' : 'h:mma';

    for (var changeInfo of vm.change.changeList) {
      if (changeInfo.property.toLowerCase() === 'time') {
        // Fix data format and format for display
        changeInfo.originalValue = moment(changeInfo.originalValue).format('YYYY/MM/DD HH:mm');
        changeInfo.originalValue = $filter('date')(DateUtilsService.dateTimeStrToDate(changeInfo.originalValue), dateTimeFormat);
        changeInfo.newValue = moment(changeInfo.newValue).format('YYYY/MM/DD HH:mm');
        changeInfo.newValue = $filter('date')(DateUtilsService.dateTimeStrToDate(changeInfo.newValue), dateTimeFormat);
      }

      // remove comments ($$=>) from the newvalue field to show it a new line
      if (changeInfo.newValue && typeof changeInfo.newValue === "string" && changeInfo.newValue.includes("$$")) {
        const posi = changeInfo.newValue.indexOf("$$");
        vm.comment = changeInfo.newValue.substr(posi + 2);
        changeInfo.newValue = changeInfo.newValue.substr(0, posi);
      }
    }
    if (vm.change.method === 'system') {
      let media = (vm.change.changeList && vm.change.changeList.length > 0 ? vm.change.changeList[0].property.toLowerCase() : "unknown");
      vm.icon = (media == "unknown"
        ? "mdi-server-off"
        : (media.includes("email") ? 'mdi-email-outline' : 'mdi-cellphone'));
    }
    else {
      vm.icon = vm.change.method === 'phone'
        ? 'mdi-book-open'
        : (vm.change.method.startsWith('API - ')
          ? 'mdi-rss'
          : vm.change.method);
    }
  }
}
